import React, { useEffect, useLayoutEffect, useState } from 'react';
import * as actionCreators from './../../actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Alert, Button, Fade, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Inputs from './../../Components/Inputs';
import NroVta from '../../Components/NroVta';
import { eliminarDiacriticosEsNum } from '../../utilities';
import Leyenda from '../../Components/Leyenda';

const options = [
  { value: '0', label: 'Casas y Deptos en Planta Baja' },
  { value: '1', label: 'Deptos 1 Piso en adelante / Casas en Countries / Barrios Cerrados' },
];

function HomeData({ saveError, codpmpol, saveHomeData, homeData, firstStep, handleChange, searchCities, provinces, cities, resetData }) {
  const { registeredAddress, address, homeType, city, squareMeters } = homeData;
  const { errorDescription, alertData, client } = saveError;
  const [mensaje, setMensaje] = useState(null);
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const navigate = useNavigate();


  const handleChangeProvinces = (province) => {
    handleChange({ step: "homeData", target: { name: 'city', value: '' } })
    !cities.filter(city => city.codprv === province.value)?.length > 0 && searchCities(province.value, firstStep.codcia)
  };

  const verifyAddress = () => {
    const filtered = registeredAddress?.filter(e => (
      e.toLowerCase() === address.toLowerCase() // || e.toLowerCase().includes(address.toLowerCase())
    ));
    return filtered?.length > 0;
  };

  const handleClose = () => {
    resetData();
    navigate("/");
    setShow(false);
  };

  const verifyForm = () => {
    if (address.length < 2) {
      setMensaje('Revise su dirección');
      return false;
    }
    if (verifyAddress()) {
      setMensaje('El cliente ya cuenta con un seguro para este domicilio');
      return false;
    }
    if (!homeType) {
      setMensaje('Revise su tipo de vivienda');
      return false;
    }
    if (!city) {
      setMensaje('Revise su ciudad');
      return false;
    }
    if (Number(squareMeters) <= 0) {
      setMensaje('Revise los metros cuadrados');
      return false;
    }
    return true;
  }

  const handleSubmit = async () => {
    if (verifyForm()) {
      setError(false);
      setIsLoading(true);
      await saveHomeData(homeData, codpmpol);
      setIsLoading(false);
    } else {
      setError(true);
    }
  }

  useEffect(() => {
    codpmpol === "" && navigate("/");
  }, []);

  useLayoutEffect(() => {
    if (!isLoading && !error) {
      if (!alertData) {
        navigate('/qs/payMethod');
      } else {
        setShow(true);
      }
    }
  }, [isLoading, error]);

  return (
    <>
      <Fade appear in>
        <div className="qs qsmargin">
          <div className="container max-shadow">
            <div className='d-flex flex-column m-0 mx-0 mb-4 scroll-off'>
              <h1 className='text-start mx-0 mt-3 fs-5 color-title-blue'>PEDIDO DE COBERTURA/DATOS HOGAR</h1>
              <p className='m-0 fw-semibold color-title-blue'>Presupuesto n° {codpmpol}</p>
            </div>
            <div className="qs-inputs row row-cols-2">
              <Inputs
                title={"Domicilio"}
                name={'address'}
                value={eliminarDiacriticosEsNum(homeData.address)}
                step={'homeData'}
              />
              <Inputs
                title={"Tipo de vivienda"}
                name={'homeType'}
                type={'select'}
                options={options}
                value={homeData.homeType}
                step={'homeData'}
              />
              <Inputs
                title={"Provincia"}
                name={'province'}
                type={'select'}
                options={provinces}
                change={handleChangeProvinces}
                value={homeData.province}
                step={'homeData'}
              />
              {
                firstStep.codcia !== 122 ?
                  <Inputs
                    title={"Localidad"}
                    name={'city'}
                    type={'select'}
                    options={cities.filter((c) => c.codprv === homeData.province)}
                    value={homeData.city}
                    step={'homeData'}
                  /> :
                  <Inputs
                    title={"Localidad"}
                    name={'city'}
                    value={homeData.city}
                    step={'homeData'}
                  />
              }
              <Inputs
                title={"Metros cuadrados"}
                name={'squareMeters'}
                type={'number'}
                value={homeData.squareMeters}
                step={'homeData'}
              />
            </div>
            {
              error &&
              <Alert className='mt-2' variant={'danger'}>
                {mensaje}
              </Alert>
            }
            <div className='row flexend'>
              {/* <div className="col-sm-6 col-lg-4 offset-lg-1">
              <CancelBuy />
            </div> */}
              <div className="col-sm-6 col-lg-4 offset-lg-4">
                <Inputs
                  type={'button'}
                  title="Continuar"
                  onClick={handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </Fade>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>¡Aviso!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{errorDescription || client}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose} className="main-btn">
            Entiendo
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

function mapStateToProps(state) {
  return {
    homeData: state.mainReducer.homeData,
    firstStep: state.mainReducer.firstStep,
    provinces: state.mainReducer.provinces,
    cities: state.mainReducer.cities,
    titularData: state.mainReducer.titularData,
    codpmpol: state.mainReducer.codpmpol,
    user: state.mainReducer.user,
    saveError: state.mainReducer.saveError,
  }
};

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators(actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeData);
